/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  Client,
  ClientsControllerArchiveV1PathParameters,
  ClientsControllerCreateV1PathParameters,
  ClientsControllerDeleteV1PathParameters,
  ClientsControllerFindAllByClientIdV1200,
  ClientsControllerFindAllByClientIdV1PathParameters,
  ClientsControllerFindAllUsersV1200,
  ClientsControllerFindAllUsersV1PathParameters,
  ClientsControllerFindAllV1200,
  ClientsControllerFindOneV1PathParameters,
  ClientsControllerPauseV1PathParameters,
  ClientsControllerRestoreV1PathParameters,
  ClientsControllerResumeV1PathParameters,
  ClientsControllerUpdateRequireTotpV1PathParameters,
  ClientsControllerUpdateV1PathParameters,
  CreateClientDto,
  UpdateClientDto,
  UpdateRequireTotpDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class ClientsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Get all users associated with a client
   */

  findAllUsers<TData = ClientsControllerFindAllUsersV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: ClientsControllerFindAllUsersV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/clients/${clientId}/users`);
  }
  /**
   * @summary Get all clients for the authenticated user
   */

  findAll<TData = ClientsControllerFindAllV1200>(): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/clients`);
  }
  /**
   * @summary Get a client by ID
   */

  findOne<TData = Client>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR }: ClientsControllerFindOneV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/clients/${clientId}`);
  }
  /**
   * @summary Enable or disable the TOTP requirement for a client
   */

  updateRequireTotp<TData = Client>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: ClientsControllerUpdateRequireTotpV1PathParameters,
    updateRequireTotpDto: UpdateRequireTotpDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/clients/v1/clients/${clientId}/require-totp`, updateRequireTotpDto);
  }
  /**
   * @summary Get all child clients associated with a parent client
   */

  findAllByClientId<TData = ClientsControllerFindAllByClientIdV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: ClientsControllerFindAllByClientIdV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/clients/${clientId}/children`);
  }
  /**
   * @summary Create a child client under a parent client
   */

  create<TData = Client>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: ClientsControllerCreateV1PathParameters,
    createClientDto: CreateClientDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/clients/${clientId}/children`, createClientDto);
  }
  /**
   * @summary Update an existing client
   */

  update<TData = Client>(
    { parentClientId, clientId = CURRENT_CLIENT_TEMPLATE_VAR }: ClientsControllerUpdateV1PathParameters,
    updateClientDto: UpdateClientDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/clients/v1/clients/${parentClientId}/children/${clientId}`, updateClientDto);
  }
  /**
   * @summary Pause a client
   */

  pause<TData = Client>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: ClientsControllerPauseV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/clients/${clientId}/children/${id}/pause`, undefined);
  }
  /**
   * @summary Resume a paused client
   */

  resume<TData = Client>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: ClientsControllerResumeV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/clients/${clientId}/children/${id}/resume`, undefined);
  }
  /**
   * @summary Archive a client
   */

  archive<TData = Client>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: ClientsControllerArchiveV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/clients/${clientId}/children/${id}/archive`, undefined);
  }
  /**
   * @summary Restore an archived client
   */

  restore<TData = Client>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: ClientsControllerRestoreV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/clients/${clientId}/children/${id}/restore`, undefined);
  }
  /**
   * @summary Delete a client
   */

  delete<TData = void>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: ClientsControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/clients/v1/clients/${clientId}/children/${id}`);
  }
}
